/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
// æå¼çé¡µé¢æ°æ®
export interface Pages {
  /** è·¯ç±æ°ç» */
  data?: PageData[];
  /** éä¸­çæ°ç»ç´¢å¼ */
  index?: number;
}

// åä¸ªæå¼çé¡µé¢æ°æ®

export interface PageData {
  /** æ é¢ */
  title?: string;
  /** è·¯ç±å°å */
  url?: string;
  // è·¯ç± + åæ°
  pureRouter: string;
}

/**
 * èåæ°æ®
 */
export class MenuData {
  // ID
  id: string;

  // ç¶ID
  parentId: string;

  // åç§°
  name: string;

  // å³é®å­
  keyWord: string;

  // å¾æ 
  icon: string;

  // æ¯å¦å±å¼
  isExpend?: boolean;

  // URL
  url?: string;

  // å­èç¹
  children?: Array<MenuData>;

  moduleId?: string;

  selectedId?: object;

  moduleName?: string;

  // æ¯å¦æå­èç¹
  hasChildren?: boolean;

  // èåèç¹é¡ºåº
  orderId?: string;

  flag?: string;

  moduleLevel?: string;

  ids?: string[];

  asMenu?: boolean;

  // è·¯ç±ä¸­çåæ°
  param: object;
}

export interface LogoConfig {
  logo?: string; // ç§æ·å¤´å
  projectName?: string; // ç³»ç»åç§°
  tenantName?: string; // ç§æ·åç§°
}
